import { Avatar, Button, Icons, useToggle } from '@commenda/kakashi';
import { TComplianceItem } from '@commenda/types/src/compliance-calendar/compliances/types';
import { ComplianceStatus } from '@prisma/client';
import { DeleteAssigneeModal } from './DeleteAssigneeModal';

export const Assignee = ({
  assignee,
  filing,
  refreshCompliances,
  hideDeleteAssignee,
  loggedInUserEmail,
}: {
  assignee: { id: string; name: string; email: string };
  filing: TComplianceItem;
  refreshCompliances: () => void;
  hideDeleteAssignee?: boolean;
  loggedInUserEmail: string;
}) => {
  const deleteAssigneeModalVisibility = useToggle();

  const isFilingCompletedOrFiled =
    filing.status === ComplianceStatus.COMPLETED ||
    filing.status === ComplianceStatus.FILED;

  return (
    <div className="flex py-lg px-xl items-center justify-between">
      <DeleteAssigneeModal
        isOpen={deleteAssigneeModalVisibility.visible}
        onClose={deleteAssigneeModalVisibility.toggle}
        filing={filing}
        onSuccess={refreshCompliances}
        assignee={assignee}
        loggedInUserEmail={loggedInUserEmail}
      />
      <div className="flex items-center gap-2.5">
        <Avatar size="sm" name={assignee.name} />
        <div className="flex flex-col">
          <span className="txt-small-medium">{assignee.name}</span>
          <span className="txt-extra-small-regular text-text-tertiary">
            {assignee.email}
          </span>
        </div>
      </div>
      {!isFilingCompletedOrFiled && !hideDeleteAssignee && (
        <div className="flex items-center gap-2.5">
          <Button
            size="sm"
            variant="link"
            className="hover:text-button-tertiary-error-fg"
            onClick={deleteAssigneeModalVisibility.toggle}
          >
            <Icons.Trash01 className="size-4" />
          </Button>
        </div>
      )}
    </div>
  );
};
